import Timeout from './timeout';
export default function createTimeout(delay) {
    return new Timeout(delay);
}
